<template> 
  <div class="content" style="overflow-y: auto;">
  <div class="fl back-color-fff borderR6" style="width: 26%;padding-bottom:15px">
  <el-input
  placeholder="输入关键字进行过滤"
  v-model="filterText" style="width: 80%; margin-top:10px;">
</el-input>

<el-tree
    :data="areaData"  
    ref="treess"
    class="mt10 mb10"
    nodeKey="guid"
    highlight-current
    :current-node-key="salesTerritoryGuid"
    :filter-node-method="filterNode"
    :props="defaultPropsOrganisation"
    @node-click="handleNodeCilck"
  >
  <div class="custom-tree-node" slot-scope="{ node,data }">
    <img :src="data.icon" alt="" style="width:18px;height:18px;">
    <span>{{ data.label }} <span class="remark-class" v-if="data.remark">（{{ data.remark }}）</span></span>
  </div>
  </el-tree>
  </div>

  <div style="width: 73%;float: right; ">
    <div class="button-area mt0">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">新增人员</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
      <div class="fr line-h40 h40 font-S16 mr16">{{staffName}}，当前销售区域有<b class="fontC-4fa1a4"> {{page.totalRows}} </b>个人员</div>
      <!-- <el-button plain size="medium">历史数据</el-button> -->
    </div>
    <div class=" back-color-fff p16" >
      <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%;" v-loading="tableLoading">
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="姓名" header-align="left" align="left"></el-table-column> 
        <el-table-column
          prop="mobileNo"
          label="手机号"
          header-align="left"
          align="left"
        ></el-table-column> 
        <el-table-column
          prop="logonUser"
          label="账号"
          header-align="left"
          align="left"
        ></el-table-column>
        <el-table-column label="操作" header-align="center" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <!-- <a class="txt-color" @click="add(2, scope.row)">编辑 | </a> -->
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
       style="padding: 16px;" 
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
</div>

    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible"  width="51%">
      <el-transfer
        filterable 
        filter-placeholder="请输入人名检索"
        :titles="['全部人员', '已选人员']"
        v-model="staffGuids"
        :props="{ key: 'guid', label: 'staffName'}"
        :data="personnelList">
      </el-transfer>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitDepartment()" v-loading.fullscreen.lock="fullscreenLoading">确定</el-button>
      </div>
    </el-dialog>
  </div> 
</template>

<script>
import areaJson from '../../assets/js/china_address_v4.js';
import citys from '../../components/citys.vue';
export default {
    components:{
    citys,
  },
  data() {
    return { 
      staffName:'',
      workareaList:'',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      superiorOrganization:[], 
      salesTerritoryGuid:'',
      defaultPropsOrganisation:{
           id: "id",
           label: "label",
           children:"children"
        },   
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        logonUser: '',
        staffName: '',
        mobileNo: '',
        staffType: '2',
        bizState: 'Y', 
        organisationGuid:''
      },
      staffDetail:'',
      tableData: [], 
      filterText: '',
      multipleSelection: [],
      tableLoading:false,
      tenantList: [],
      addressOptions: areaJson,
      operationUnitList: [],
      fullscreenLoading: false,
      personnelList:[],
      staffGuids:[],
      areaData:[],
    };
  },
  watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
  created() {
    // 列表
    this.staffName = this.$route.query.tenantName;
    this.getOrgUnitRegion();
    this.getPersonnelList();
    // this.getAppsideData();
    // this.getPositionListData();
    // this.getTenantOperationRelList();
    // this.getOperationUnitList();
  },
  methods: {  
    handleNodeCilck(data){
      console.log(data);
      let self = this;
      if(data.org == 1){  
        // self.$message.error('请选择销售区域！');
        self.salesTerritoryGuid = '';
        self.salesTerritoryName = '';
        return
      }
      self.salesTerritoryGuid = data.id;
      self.salesTerritoryName = data.label;
      self.getData();
      // node.
    },
    getOrgUnitRegion(){
      let self = this;   
      let tenantGuid = self.$store.getters.getTenantGuid;
      let sendTenantGuid = self.$route.query.tenantGuid;
      self.api.get(`/${serverConfig.msPersonnelService}/organisation/data/get-org-unit-region?tenantGuid=`+tenantGuid+'&bizState=Y&sendTenantGuid='+sendTenantGuid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.areaData = res.data.data;
          if(self.areaData){
            self.treeData(self.areaData);
            this.$nextTick(function(){
              self.salesTerritoryGuid = self.areaData[0].id;
              self.salesTerritoryName = self.areaData[0].label;
              self.getData();
            })
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    treeData(areaData) {
        var self = this;
        // const treeData = [];
        // const getPerson = () => {};
        const fn = (tree) => {
          tree.forEach(async (k) => {
            k.org = 1;
            k.label = k.organisationName;
            k.id = k.guid;
            k.icon = require("../../assets/images/ico_ora.png")
            // 根据id获取人员数据,(注意转为树类型)
            if (k) {
              // const person = await self.getStaff(k.guid);
              k.territoryLists = [];
              if(k.territoryList){
                k.territoryList.forEach((d)=>{
                  let item = {
                    org:2,
                    id:d.guid,
                    label:d.territoryName,
                    icon:require("../../assets/images/icon_quyu.png")
                  }
                  k.territoryLists.push(item);
                })
              }
              const person = k.territoryLists;
              const isValid = (val) => {
                return val && val !== null && JSON.stringify(val) !== '[]';
              };
              // 将人员数据拼接到chilren里面
              if (k.children) {
                fn(k.children);
                isValid(person) && (k.children = [...k.children, ...person]);
                // 有子元素，需要调用自身
              } else {
                isValid(person) && (k.children = person);
              }
            }
          });
        };
        fn(areaData);
        console.log(areaData);
      }, 
    
    filterNode(value, data) {
        if (!value) return true;
        return data.organisationName.indexOf(value) !== -1;
      },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        logonUser: '',
        staffName: '',
        mobileNo: '',
        staffType: '1',
        bizState: 'Y', 
        organisationGuid:'',
      };
      self.getData(true);
    },
    add(flg, row) {
      let self = this;
      if(!self.salesTerritoryGuid){
        self.$message.error('请先选择左侧销售区域!');
        return
      }
      self.staffGuids = []; 
      if (flg == 1) {
        self.textTitle = '新增人员'; 
        if(self.personnelList){
          self.dialogFormVisible = true;
        }else{
          self.$message.error('当前企业没有备案人员!');
          return
        }
      }
    },
    getPersonnelList() {
      let self = this;
      let promse = {
        tenantGuid: self.$store.getters.getTenantGuid,
        sendTenantGuid: self.$route.query.tenantGuid,
        pageIndex:1,
        pageSize:-1,
        staffType:2
      }
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, promse).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.personnelList = res.data.data.records; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    getData() {
      let self = this; 
      self.api.get(`/${serverConfig.msPersonnelService}/sales-territory/data/get-staff-sales-territory-with-stafftype?salesTerritoryGuid=`+self.salesTerritoryGuid+'&staffType=2'+'&tenantGuid='+self.$store.getters.getTenantGuid).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data.records; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msPersonnelService}/sales-territory/data/delete-staff-sales-territory`,{'salesTerritoryGuid':self.salesTerritoryGuid,'staffGuid':self.multipleSelection,'tenantGuid':self.$route.query.tenantGuid})
            .then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除人员成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    submitDepartment(){
      let self = this;
      if(!self.salesTerritoryGuid){
        self.$message.error('请先选择左侧组织!');
        return
      }
      if(!self.staffGuids){
        self.$message.error('请勾选人员!');
        return
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msPersonnelService}/sales-territory/data/add-staff-sales-territory`,{'salesTerritoryGuid':self.salesTerritoryGuid,'salesTerritoryName':self.salesTerritoryName,'staffGuid':self.staffGuids,'tenantGuid':self.$route.query.tenantGuid}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogFormVisible = false;
          self.tableLoading = false;
          self.$message.success('添加人员成功');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    }
  },
};
</script>
<style scoped>
.el-col-5 {
  width: 33%;
}
.ipt-sty{
  width: 69%!important;
}
/deep/.el-tree-node__label{
  width: 80%;
  white-space: normal;
  overflow: hidden;
  text-align: left;
}
/deep/ .el-transfer-panel {
    text-align: left;
    width: 33%; 
}
.el-tree-node__content{
  height: auto;
}
.radio-ora{
  margin-right: 12px;
}
</style>
